import * as React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import { initReducers } from './apps';

// TODO: Remove me
import { login } from '~/apps/shared/actions/auth';

// Required for the redux dev tools support
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__: any;
  }
}

export default function configureStore(router) {
  const rootReducer = initReducers();

  const middleware = compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
  );

  const store = createStore(rootReducer, middleware);

  router.connectStore(store);

  return store;
};
